import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            screen: yup.string().required(__(`form.screen.error`))
        })
    )
}

export default validators
